import { render, staticRenderFns } from "./UpdateCompanyInfo.vue?vue&type=template&id=4587c812&scoped=true&"
import script from "./UpdateCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateCompanyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4587c812",
  null
  
)

export default component.exports